import logo from "./logo.svg";
import david from "./images/david.png";
import "./App.css";
import wave from "./images/200.gif";
import dick from "./images/dick.png";
import brain from "./images/brain.png";
import ankle from "./images/ankle1.png";
import { BrowserRouter, Route, Routes, Link } from "react-router-dom";
import { useState } from "react";
import Home from "./Home";
import Scan from "./Scan";
import Continue from "./Continue";
import EggAudio from "./Eggboy_v3.mp3";
import Audplay from "./AudPlay";
import Audplay2 from "./Audplay2";
function App() {
  const [firstAud, setFirstAud] = useState(false);

  let poem = [
    [
      "As it stood, it was a table of additions, much like certain schizophrenics’ drawings, described as 'overstuffed,’ and if finished it was only in so far as there was no way of adding anything more to it...",

      "the table having become more and more an accumulation, less and less a table... It was not intended for any specific purpose, for anything one expects of a table.",
    ],
    [
      "Heavy, cumbersome, it was virtually immovable. One didn’t know how to handle it (mentally or physically). Its top surface, the useful part of the table, having been gradually reduced, was disappearing, with so little relation to the clumsy framework that the thing did not strike one as a table, but as some freak piece of furniture... ",
      "an unfamiliar instrument for which there was no purpose...",
    ],
    [
      "A dehumanized table, nothing cozy about it, nothing ‘middle-class ,’ nothing rustic, nothing countrified , not a kitchen table or a work table.",

      "A table which lent itself to no function, self-protective, denying itself to service and communication alike. <br><br> There was something stunned about it, something petrified. <br><br>Perhaps it suggested a stalled engine.",
    ],
  ];

  const [i, setI] = useState(0);
  const [poemStep, setPoemStep] = useState(poem[i]);
  const [imageStep, setImageStep] = useState([]);
  const [imgClass, setImgClass] = useState("");
  const [c1Pic, setC1Pic] = useState();
  const [c2Pic, setC2Pic] = useState();
  const [c3Pic, setC3Pic] = useState();
  const [hasClicked, setHasClicked] = useState(false);

  function changeBackground(x) {
    if (x === 1) {
      setC1Pic(wave);
      setI(i + 1);
      setPoemStep(poem[i]);
      setImageStep(brain);
      setImgClass("brain");
    } else if (x === 2) {
      setC2Pic(wave);
      setI(i + 1);
      setPoemStep(poem[i]);
      setImageStep(dick);
      setImgClass("dick");
    } else {
      setC3Pic(wave);
      setI(i + 1);
      setPoemStep(poem[i]);
      setImageStep(ankle);
      setImgClass("ankle");
    }
  }

  if (hasClicked === false) {
    return (
      <div className="centerGrid" onClick={() => setHasClicked(true)}>
        <h1>DÉSIRE</h1>
      </div>
    );
  }

  return (
    <>
      {firstAud === false && <Audplay />}
      {firstAud === true && <Audplay2 />}
      <BrowserRouter>
        <Routes>
          <Route
            path="/scan"
            element={
              <>
                <Scan
                  poemStep={poemStep}
                  imageStep={imageStep}
                  imgClass={imgClass}
                  i={i}
                />
              </>
            }
          />
          <Route
            path="/"
            element={
              <div className="App">
                <div className="davidDiv">
                  {i < 3 && (
                    <Link to="/scan">
                      <div
                        className="circle1"
                        onClick={() => changeBackground(1)}
                      >
                        <img src={c1Pic}></img>
                      </div>
                    </Link>
                  )}
                  {i > 2 && (
                    <div
                      className="circle1"
                      onClick={() => changeBackground(1)}
                    >
                      <img src={c1Pic}></img>
                    </div>
                  )}
                  {i < 3 && (
                    <Link to="scan">
                      <div
                        className="circle2"
                        onClick={() => changeBackground(2)}
                      >
                        <img src={c2Pic}></img>
                      </div>
                    </Link>
                  )}
                  {i > 2 && (
                    <div
                      className="circle2"
                      onClick={() => changeBackground(1)}
                    >
                      <img src={c1Pic}></img>
                    </div>
                  )}
                  {i < 3 && (
                    <Link to="scan">
                      <div
                        className="circle3"
                        onClick={() => changeBackground(3)}
                      >
                        <img src={c3Pic}></img>
                      </div>
                    </Link>
                  )}
                  {i > 2 && (
                    <div
                      className="circle3"
                      onClick={() => changeBackground(1)}
                    >
                      <img src={c1Pic}></img>
                    </div>
                  )}

                  <img src={david}></img>
                </div>
                <Link to="/continue">
                  {i > 2 && (
                    <button onClick={() => setFirstAud(true)}>Continue</button>
                  )}
                </Link>
              </div>
            }
          />
          <Route path="/continue" element={<Continue />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
